import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import classnames from 'classnames';
import styles from './banner.css';

class Banner extends Component {
  render() {
    return (
      <div
        styleName={classnames('banner', this.props.style || 'info')}
        style={{ display: this.props.content.length ? 'block' : 'none' }}
      >
        <ul>
          {this.props.content.map(function(item, i) {
            return <li key={i} dangerouslySetInnerHTML={{ __html: item }} />;
          })}
        </ul>
      </div>
    );
  }
}

Banner.propTypes = {
  content: PropTypes.array,
  style: PropTypes.oneOf(['info', 'warning', 'error']),
};

export default CSSModules(Banner, styles, { allowMultiple: true });
